// extracted by mini-css-extract-plugin
export var cardIcon = "_50-4";
export var checkboxCard = "_50-0";
export var checkboxCardSelected = "_50-3";
export var disabled = "_50-1";
export var outerBorder = "_50-2";
export var spacerMedium = "_50-7";
export var spacerSmall = "_50-6";
export var spacerXsmall = "_50-5";